// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__CJe3v","header":"ReportDetails_header__2-Okv","title":"ReportDetails_title__1FY2h","left":"ReportDetails_left__1e8an"};